import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import Cookies from "js-cookie";
import Landingheader from "./Landing/Landingheader";
import ScrollToTop from "./ScrollToTop";

const HelpPage = () => {
const client_token = Cookies.get('user_token');
const admin_token = Cookies.get('Admin_token');
const [is_logged_in,setIs_logged_in] = useState(false);

  useEffect(() => {
    if(client_token || admin_token){
      setIs_logged_in(true);
    }else{
    setIs_logged_in(false);
    }
  },[client_token,admin_token])

  // State to track which FAQ accordion is open
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const faqs = [
    {
      question: "How do I book a land surveying service?",
      answer: "Navigate to the 'Services' page, select the specific survey type you need (e.g., Boundary, Subdivision, or Topographic), click 'Book Service', and fill out your land details on the booking form."
    },
    {
      question: "What is the difference between a Boundary and Topographic survey?",
      answer: "A Boundary Survey identifies your exact legal property lines and corners. A Topographic Survey maps out the physical features of the land, including elevation scales, trees, buildings, and utility systems."
    },
    {
      question: "How can I check the status of my survey request?",
      answer: "Log into your account dashboard. at the top of website look navbar in that section click the 'Request Progressh', you can view real-time status updates directly from your assigned surveyor."
    },
    {
      question: "How long does a typical survey take to finish?",
      answer: "Fieldwork generally takes 1 to 3 days depending on property size and vegetation. Final stylized CAD maps and documentation are usually delivered to your dashboard within 5 to 7 business days."
    }
  ];

  return (
      <>
    { is_logged_in ? (<><Landingheader /></>) : (<><Header /></>)}
    <div className="min-h-screen bg-slate-50 text-slate-800">
      {/* CHANGED BANNER BACKGROUND: 
        Swapped bg-[#1A3D6D] for bg-slate-100 border-b border-slate-200.
        Updated text colors from white/mint to your brand deep blue & slate-600.
      */}
      <ScrollToTop />
      <div className="px-4 py-16 text-center border-b bg-slate-100 border-slate-200">
        <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight text-[#1A3D6D]">
          Support Center
        </h1>
        <p className="max-w-xl mx-auto mt-3 text-sm font-medium text-slate-600 md:text-base">
          Need assistance with your survey project? Browse our documentation or get in touch with our operations team.
        </p>
      </div>

      <div className="max-w-4xl px-4 py-12 mx-auto">
        {/* Quick Contact Cards */}
        <div className="grid grid-cols-1 gap-6 mb-12 md:grid-cols-2">
          <div className="flex flex-col justify-between p-6 bg-white border shadow-sm rounded-xl border-slate-200">
            <div>
              <h3 className="text-lg font-bold text-[#1A3D6D] mb-2">Submit a Ticket</h3>
              <p className="mb-4 text-sm text-slate-600">
                Have an issue with your account, billing, or existing survey data coordinates? Reach out directly.
              </p>
            </div>
            <Link 
              to="/contact" 
              className="inline-block text-center w-full bg-[#1A3D6D] hover:bg-[#1A3D6D]/90 text-white font-semibold py-2.5 px-4 rounded-lg transition-colors"
            >
              Contact Support
            </Link>
          </div>

          <div className="flex flex-col justify-between p-6 bg-white border shadow-sm rounded-xl border-slate-200">
            <div>
              <h3 className="text-lg font-bold text-[#1A3D6D] mb-2">Explore Resources</h3>
              <p className="mb-4 text-sm text-slate-600">
                Read our in-depth guides about land boundaries, subdivision regulations, and legal survey standards.
              </p>
            </div>
            <Link 
              to="/explore" 
              className="inline-block text-center w-full border border-[#1A3D6D] text-[#1A3D6D] hover:bg-slate-50 font-semibold py-2.5 px-4 rounded-lg transition-colors"
            >
              View Documentation
            </Link>
          </div>
        </div>

        {/* FAQ Accordion Section */}
        <div className="p-6 bg-white border shadow-sm rounded-xl border-slate-200 md:p-8">
          <h2 className="text-2xl font-bold text-[#1A3D6D] mb-6 border-b pb-4">
            Frequently Asked Questions
          </h2>
          
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className="pb-4 border-b border-slate-100">
                <button
                  onClick={() => toggleFaq(index)}
                  className="w-full flex items-center justify-between text-left font-semibold text-slate-800 hover:text-[#FF9800] transition-colors focus:outline-none py-2"
                >
                  <span>{faq.question}</span>
                  <svg
                    className={`w-5 h-5 text-slate-500 transform transition-transform duration-200 ${openFaq === index ? "rotate-180" : ""}`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                
                {/* Accordion expandable panel */}
                <div 
                  className={`mt-2 text-sm text-slate-600 leading-relaxed overflow-hidden transition-all duration-300 ${
                    openFaq === index ? "max-h-40 opacity-100" : "max-h-0 opacity-0"
                  }`}
                >
                  <p className="pt-1">{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  <Footer />
  </>
  );
};

export default HelpPage;